import { render, staticRenderFns } from "./Variavel.vue?vue&type=template&id=64bc2972"
import script from "./Variavel.vue?vue&type=script&lang=js"
export * from "./Variavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports